const MAX_SET_TIMEOUT_DELAY_MS = 2 ** 31 - 1;

// A browser runs a setTimeout longer than 2^31-1 ms at once, so a longer delay is walked in steps.
export class Timer {
  private handle: ReturnType<typeof setTimeout> | undefined;

  start(delayMs: number, onDue: () => void): void {
    this.clear();
    const stepMs = Math.min(delayMs, MAX_SET_TIMEOUT_DELAY_MS);
    this.handle = setTimeout(
      () => (stepMs < delayMs ? this.start(delayMs - stepMs, onDue) : onDue()),
      stepMs,
    );
  }

  clear(): void {
    clearTimeout(this.handle);
    this.handle = undefined;
  }
}
